import { render, staticRenderFns } from "./FacturasDistribuidor.vue?vue&type=template&id=3ec9e722&scoped=true&"
import script from "./FacturasDistribuidor.vue?vue&type=script&lang=js&"
export * from "./FacturasDistribuidor.vue?vue&type=script&lang=js&"
import style0 from "./transit-list.css?vue&type=style&index=0&id=3ec9e722&scoped=true&lang=css&"
import style1 from "./FacturasDistribuidor.vue?vue&type=style&index=1&id=3ec9e722&scoped=true&lang=css&"
import style2 from "./FacturasDistribuidor.vue?vue&type=style&index=2&id=3ec9e722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9e722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VPagination,VProgressLinear,VSelect,VSnackbar,VSpacer,VTextField})
